import { c as _c } from "react/compiler-runtime";
import { CollapsibleSection } from '@/components/collapsible';
import { CheckboxGroupInput, CheckboxInput, TextInput, type FieldTypeCheckbox } from '@/components/inputs';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { FIELD_AVAILABILITY, FIELD_BRAND, FIELD_IS_ON_SALE, FIELD_MERCHANT, FIELD_PRICE_FROM, FIELD_PRICE_TO, SearchFormValuesGCSS } from './hooks/useGcssSearch';
import { UseQueryResult } from '@tanstack/react-query';
import { PropsWithChildren } from 'react';
function PriceFilter(t0) {
  const $ = _c(13);
  const {
    initialValues
  } = t0;
  const {
    t
  } = useTranslation("gcss");
  const t1 = initialValues[FIELD_PRICE_FROM];
  let t2;
  if ($[0] !== t) {
    t2 = fieldRenderProps => <TextInput {...fieldRenderProps} label={t("form.price.from")} />;
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <Field name={FIELD_PRICE_FROM} min={0} initialValue={t1} type="number">{t2}</Field>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = initialValues[FIELD_PRICE_TO];
  let t5;
  if ($[5] !== t) {
    t5 = fieldRenderProps_0 => <TextInput {...fieldRenderProps_0} label={t("form.price.to")} />;
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <Field name={FIELD_PRICE_TO} type="number" min={0} initialValue={t4}>{t5}</Field>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t6) {
    t7 = <div className="flex gap-2 pt-2">{t3}{t6}</div>;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}
function CheckboxFilter(t0) {
  const $ = _c(13);
  const {
    initialValues
  } = t0;
  const {
    t
  } = useTranslation("gcss");
  const t1 = !!initialValues[FIELD_AVAILABILITY];
  let t2;
  if ($[0] !== t) {
    t2 = fieldRenderProps => <div className="mb-2"><CheckboxInput {...fieldRenderProps} label={t("form.availability.inStock")} /></div>;
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <Field name={FIELD_AVAILABILITY} initialValue={t1} type="checkbox">{t2}</Field>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = !!initialValues[FIELD_IS_ON_SALE];
  let t5;
  if ($[5] !== t) {
    t5 = fieldRenderProps_0 => <div><CheckboxInput {...fieldRenderProps_0} label={t("form.availability.isOnSale")} /></div>;
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <Field name={FIELD_IS_ON_SALE} initialValue={t4} type="checkbox">{t5}</Field>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t6) {
    t7 = <>{t3}{t6}</>;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}
function MerchantFilter(t0) {
  const $ = _c(7);
  const {
    initialValues,
    merchantsFilterResult
  } = t0;
  let t1;
  if ($[0] !== merchantsFilterResult.data) {
    t1 = [{
      type: "wrappedcheckboxselectmultiple",
      choices: merchantsFilterResult.data
    }];
    $[0] = merchantsFilterResult.data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const fields = t1;
  const t2 = initialValues[FIELD_MERCHANT];
  let t3;
  if ($[2] !== fields) {
    t3 = fieldRenderProps => <div><CheckboxGroupInput {...fieldRenderProps} fields={fields} /></div>;
    $[2] = fields;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <Field name={FIELD_MERCHANT} value={t2}>{t3}</Field>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
function BrandFilter(t0) {
  const $ = _c(7);
  const {
    initialValues,
    brandsFilterResult
  } = t0;
  let t1;
  if ($[0] !== brandsFilterResult.data) {
    t1 = [{
      type: "wrappedcheckboxselectmultiple",
      choices: brandsFilterResult.data
    }];
    $[0] = brandsFilterResult.data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const fields = t1;
  const t2 = initialValues[FIELD_BRAND];
  let t3;
  if ($[2] !== fields) {
    t3 = fieldRenderProps => <div><CheckboxGroupInput {...fieldRenderProps} fields={fields} /></div>;
    $[2] = fields;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <Field value={t2} name={FIELD_BRAND}>{t3}</Field>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
function SkeletonWrapper(t0) {
  const $ = _c(7);
  const {
    children,
    isPending,
    large
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <hr className="bg-light-gray-300" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children || $[2] !== isPending || $[3] !== large) {
    t2 = isPending ? <div className="animate-pulse py-4"><div className="h-6 w-40 max-w-full rounded-sm bg-slate-200" />{large && <div className="mt-6 h-14 w-full rounded-sm bg-slate-200" />}</div> : children;
    $[1] = children;
    $[2] = isPending;
    $[3] = large;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
interface Props {
  initialValues: Partial<SearchFormValuesGCSS>;
  brandsFilterResult: UseQueryResult<{
    label: string;
    value: string;
  }[] | undefined, Error>;
  merchantsFilterResult: UseQueryResult<{
    label: string;
    value: string;
  }[] | undefined, Error>;
  isPending: boolean;
}
export function Filter(props) {
  const $ = _c(54);
  const {
    t
  } = useTranslation("gcss");
  const t0 = props.isPending;
  let t1;
  if ($[0] !== t) {
    t1 = t("form.price.label");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = props.initialValues[FIELD_PRICE_FROM];
  const t3 = props.initialValues[FIELD_PRICE_TO];
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = <PriceFilter initialValues={{
      [FIELD_PRICE_FROM]: t2,
      [FIELD_PRICE_TO]: t3
    }} />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1 || $[6] !== t4) {
    t5 = <CollapsibleSection isInitiallyOpen={true} title={t1}>{t4}</CollapsibleSection>;
    $[5] = t1;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== props.isPending || $[9] !== t5) {
    t6 = <SkeletonWrapper isPending={t0} large={true}>{t5}</SkeletonWrapper>;
    $[8] = props.isPending;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = props.isPending;
  let t8;
  if ($[11] !== t) {
    t8 = t("form.availability.label");
    $[11] = t;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = props.initialValues[FIELD_AVAILABILITY];
  const t10 = props.initialValues[FIELD_IS_ON_SALE];
  let t11;
  if ($[13] !== t10 || $[14] !== t9) {
    t11 = <CheckboxFilter initialValues={{
      [FIELD_AVAILABILITY]: t9,
      [FIELD_IS_ON_SALE]: t10
    }} />;
    $[13] = t10;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11 || $[17] !== t8) {
    t12 = <CollapsibleSection title={t8}>{t11}</CollapsibleSection>;
    $[16] = t11;
    $[17] = t8;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== props.isPending || $[20] !== t12) {
    t13 = <SkeletonWrapper isPending={t7}>{t12}</SkeletonWrapper>;
    $[19] = props.isPending;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  const t14 = props.isPending;
  let t15;
  if ($[22] !== t) {
    t15 = t("form.merchant.label");
    $[22] = t;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  const t16 = props.initialValues[FIELD_MERCHANT];
  let t17;
  if ($[24] !== t16) {
    t17 = {
      [FIELD_MERCHANT]: t16
    };
    $[24] = t16;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== props.merchantsFilterResult || $[27] !== t17) {
    t18 = <MerchantFilter initialValues={t17} merchantsFilterResult={props.merchantsFilterResult} />;
    $[26] = props.merchantsFilterResult;
    $[27] = t17;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t15 || $[30] !== t18) {
    t19 = <CollapsibleSection title={t15}>{t18}</CollapsibleSection>;
    $[29] = t15;
    $[30] = t18;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== props.isPending || $[33] !== t19) {
    t20 = <SkeletonWrapper isPending={t14}>{t19}</SkeletonWrapper>;
    $[32] = props.isPending;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  const t21 = props.isPending;
  let t22;
  if ($[35] !== t) {
    t22 = t("form.brand.label");
    $[35] = t;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  const t23 = props.initialValues[FIELD_BRAND];
  let t24;
  if ($[37] !== t23) {
    t24 = {
      [FIELD_BRAND]: t23
    };
    $[37] = t23;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  let t25;
  if ($[39] !== props.brandsFilterResult || $[40] !== t24) {
    t25 = <BrandFilter initialValues={t24} brandsFilterResult={props.brandsFilterResult} />;
    $[39] = props.brandsFilterResult;
    $[40] = t24;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] !== t22 || $[43] !== t25) {
    t26 = <CollapsibleSection title={t22}>{t25}</CollapsibleSection>;
    $[42] = t22;
    $[43] = t25;
    $[44] = t26;
  } else {
    t26 = $[44];
  }
  let t27;
  if ($[45] !== props.isPending || $[46] !== t26) {
    t27 = <SkeletonWrapper isPending={t21}>{t26}</SkeletonWrapper>;
    $[45] = props.isPending;
    $[46] = t26;
    $[47] = t27;
  } else {
    t27 = $[47];
  }
  let t28;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <hr className="bg-light-gray-300" />;
    $[48] = t28;
  } else {
    t28 = $[48];
  }
  let t29;
  if ($[49] !== t13 || $[50] !== t20 || $[51] !== t27 || $[52] !== t6) {
    t29 = <div className="pt-4 md:col-span-1 md:pt-8">{t6}{t13}{t20}{t27}{t28}</div>;
    $[49] = t13;
    $[50] = t20;
    $[51] = t27;
    $[52] = t6;
    $[53] = t29;
  } else {
    t29 = $[53];
  }
  return t29;
}